/**
 * JS で生成する UI 文言の多言語化
 *
 * WordPress 側（inc/i18n.php）が表示言語に翻訳した文言を
 * <script type="application/json" data-js="i18n"> に出力するので、それを参照する。
 * JSON が無い環境（静的 HTML 等）では下記の日本語を使う。
 */
const FALLBACK_LABELS = {
  mapLoading: 'マップを読み込み中...',
  watchMovie: '映像を見る',
  readStory: '物語をよむ',
  linkDefault: '詳しく見る',
  prevSpot: '前のスポット',
  nextSpot: '次のスポット',
  prevMovie: '前の動画',
  nextMovie: '次の動画',
  shootingSpot: '撮影場所',
  shootingSpotImg: '撮影場所の画像',
  areaMinamiaizu: '南会津',
  areaShimogo: '下郷',
  areaAizuwakamatsu: '会津若松',
};

const FALLBACK_MAP_LANGUAGE = 'ja';

const loadData = () => {
  const el = document.querySelector('[data-js="i18n"]');
  if (!el) return {};
  try {
    return JSON.parse(el.textContent) || {};
  } catch (e) {
    console.error('i18n JSON の解析に失敗しました', e);
    return {};
  }
};

const data = loadData();
const labels = { ...FALLBACK_LABELS, ...(data.labels || {}) };

/** UI 文言を取得する */
export const i18n = (key) => labels[key] ?? key;

/** Google Maps JavaScript API に渡す言語コード */
export const mapLanguage = data.mapLanguage || FALLBACK_MAP_LANGUAGE;
